export class LoaderMessage {
}